<div class="create_popup">
    <div class="modal-body">
        <!-- <form [formGroup]="createForm" class="mb-3"> -->
            <div class="">
                <div class="row">
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Name:</label>
                        <span>{{userDetails?.fullName}}</span>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Email:</label>
                        <span>{{userDetails?.email}}</span>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Mobile:</label>
                        <span>{{userDetails?.mobile}}</span>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Pan Number:</label>
                        <span>{{userDetails?.panNumber}}</span>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                       <label class="form-label">GST Number:</label>
                       <span>{{userDetails?.gstNumber}}</span>
                   </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">User Name:</label>
                        <span>{{userDetails?.userName}}</span>
                    </div>

                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Department:</label>
                        <span>{{userDetails?.department}}</span>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                       <label class="form-label">City:</label>
                       <span>{{userDetails?.city}}</span>
                   </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                       <label class="form-label">State:</label>
                       <span>{{userDetails?.state}}</span>
                   </div>
                     <div class="col-md-4 col-sm-6 mb-3 ">
                        <label class="form-label">Address </label>
                        <span>{{userDetails?.address1}}</span>
                    </div>
                </div>
            </div>
        <!-- </form> -->
    </div>                            
</div>    